export const PLAYER_COLOR_NAMES = [
  "Red",
  "Blue",
  "Purple",
  "Green",
  "Orange",
  "Teal",
  "Pink",
  "Yellow",
] as const;

export const PLAYER_COLOR_HEX: Record<(typeof PLAYER_COLOR_NAMES)[number], string> = {
  Red: "#E74C3C",
  Blue: "#3498DB",
  Purple: "#9B59B6",
  Green: "#2ECC71",
  Orange: "#E67E22",
  Teal: "#1ABC9C",
  Pink: "#E91E63",
  Yellow: "#D4A520",
};

export const DEAD_PLAYER_COLOR = "#999999";

export function resolveColorDetails(name: string | null | undefined): {
  hex?: string;
  index?: number;
  baseName?: string;
} {
  if (!name) {
    return {};
  }
  const baseName = name.split("-")[0]?.trim();
  if (!baseName) {
    return {};
  }
  const typedName = PLAYER_COLOR_NAMES.find((color) => color === baseName);
  if (!typedName) {
    return {};
  }
  return {
    baseName: typedName,
    hex: PLAYER_COLOR_HEX[typedName],
    index: PLAYER_COLOR_NAMES.indexOf(typedName),
  };
}
